import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[authorityLabsEmailLink]'
})
export class EmailLinkDirective implements OnInit {
  @Input('authorityLabsEmailLink') email: string;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.isEmail(this.email)) {
      const link = document.createElement('a');
      link.href = 'mailto:' + this.email;
      link.innerHTML = this.email;
      this.el.nativeElement.innerHTML = '';
      this.el.nativeElement.appendChild(link);
    }
  }

  private isEmail(email: string): boolean {
    // Regular expression to validate email format
    const emailRegex = /^\S+@\S+\.\S+$/;
    return emailRegex.test(email);
  }
}
